import CoconeuseBioTemplate from "../../components/coconeuses/CoconeuseBioTemplate";

const CoconeuseAmeDivaValouse = () => (
  <CoconeuseBioTemplate
    name="Âme Diva"
    subtitle="La voix comme médecine · Le chant comme passage"
    mainPhoto="https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/2d7ag7eo_DSC00736.jpg"
    bioText={[
      "Âme Diva nous guide dans l'art de libérer la voix.",
      "À travers la technique vocale, le chant intuitif et le chant canalisé, elle ouvre un espace où la voix devient un soin.",
      "Un espace où la voix devient un passage — et où quelque chose de plus vrai peut enfin se dire.",
      "Quand la voix s'ouvre, le vivant circule à nouveau.",
    ]}
    galleryPhotos={[
      "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/2dky9e18_DSC01736.jpg",
      "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/w5qk4tnk_DSC03886.jpg",
      "https://customer-assets.emergentagent.com/job_5c218319-678c-4c56-b4c3-2039fdc76918/artifacts/wi6t4e6p_DSC01325.jpg",
    ]}
    expertise={["Libération de la voix", "Chant intuitif", "Expression vocale"]}
    backPath="/coconeuses#profil-ame-diva"
    backLabel="Retour aux Coconeuses"
  />
);

export default CoconeuseAmeDivaValouse;
